/* eslint-disable jsx-a11y/accessible-emoji */

/* eslint-disable func-names */
import getWindow from '@uswitch/ev-utils/lib/get-window';
import { ErrorBoundary } from 'react-error-boundary';
import { isProd } from '@uswitch/ev-utils/lib/helpers/env';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var handleError = function handleError(error) {
  console.log('ErrorBoundary hit; component render failed', error);

  if (getWindow().Sentry) {
    getWindow().Sentry.captureException(error);
  }
};

var FallbackError = function FallbackError(_ref) {
  var _ref$error = _ref.error,
      error = _ref$error === void 0 ? {} : _ref$error,
      _ref$info = _ref.info,
      info = _ref$info === void 0 ? {} : _ref$info;

  if (isProd) {
    return null;
  } else {
    return _jsxs("div", {
      sx: {
        border: ' 1px solid',
        borderColor: 'red',
        p: '1em'
      },
      children: [_jsx("h1", {
        sx: {
          textAlign: 'center'
        },
        children: "\uD83D\uDD25\uD83D\uDD25\uD83D\uDD25 Component render failed \uD83D\uDD25\uD83D\uDD25\uD83D\uDD25 "
      }), _jsx("pre", {
        sx: {
          whiteSpace: 'pre-wrap'
        },
        children: error.message
      }), _jsx("pre", {
        sx: {
          whiteSpace: 'pre-wrap'
        },
        children: info.componentStack
      })]
    });
  }
};

var ClientErrorBoundary = function ClientErrorBoundary(_ref2) {
  var children = _ref2.children;
  return _jsx(ErrorBoundary, {
    FallbackComponent: FallbackError,
    onError: handleError,
    children: children
  });
};

export default ClientErrorBoundary;